'use client'

import { useEffect, useState } from 'react'
import { initPostHog, optIn, optOut } from '@/lib/posthog'

export default function AnalyticsOptOut() {
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    let active = true
    void initPostHog().then((client) => {
      if (active) setDisabled(Boolean(client?.has_opted_out_capturing()))
    })
    return () => { active = false }
  }, [])

  const toggle = () => {
    if (disabled) optIn()
    else optOut()
    setDisabled((value) => !value)
  }

  return (
    <div>
      <h2 className="text-xl sm:text-2xl font-semibold text-foreground mb-4">Analytics preferences</h2>
      <p className="text-muted-foreground leading-relaxed mb-4">
        You can disable or re-enable optional website analytics on this browser at any time.
      </p>
      <button
        type="button"
        onClick={toggle}
        className="min-h-11 rounded-full border border-current px-5 text-foreground"
      >
        {disabled ? 'Enable analytics' : 'Disable analytics'}
      </button>
    </div>
  )
}
